import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fl-token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Errore";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export function getFavorites() {
  try {
    return JSON.parse(localStorage.getItem("fl-favs") || "[]");
  } catch {
    return [];
  }
}

export function isFavorite(slug) {
  return getFavorites().includes(slug);
}

export function toggleFavorite(slug) {
  const favs = getFavorites();
  const idx = favs.indexOf(slug);
  let added;
  if (idx >= 0) {
    favs.splice(idx, 1);
    added = false;
  } else {
    favs.push(slug);
    added = true;
  }
  localStorage.setItem("fl-favs", JSON.stringify(favs));
  if (added && !localStorage.getItem(`fl-liked-${slug}`)) {
    localStorage.setItem(`fl-liked-${slug}`, "1");
    api.post(`/items/${slug}/like`).catch(() => {});
  }
  return added;
}
